<template>
    <div>
        <div class="clearbox"></div> 
        <img class="bannerbox"  src="../../static/images/banner2.jpg" /> 
        <div class="clearbox"></div>
        
        <div class="contentlist"> 
            <div class="index-width"> 
                <div class="listbox-left"> 
                    <div class="position">
                        <span>当前位置：<a ><router-link to="/">首页</router-link></a>&nbsp;&gt;&gt;&nbsp;<a @click="originRouter">业务领域</a> <template v-if="type">&nbsp;&gt;&gt;&nbsp;<a >{{typeTitle}}</a></template></span>
                    </div> 
                    <ul class="list_c">
                        <li  v-for="(item,index) in listDataNew"><a @click="goDetails(item)" :data-detail='item'>{{item.text}}</a><span>{{item.time}}</span></li>
                    </ul>

                    <div id="pages" class="text-c">
                        <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="1">
                        </el-pagination>
                    </div> 

                </div> 
                
                <boxRight :key="Date.now()" :mainTitle="mainTitle" :liData="liData" @routerData="routerData"></boxRight>
            </div> 
        </div> 
        <div class="clearbox"></div> 
        <footerNew></footerNew>
    </div>
</template>

<script>
    import boxRight from '@/component/listBoxRight.vue'
    import footerNew from '@/component/footerNew.vue'
    export default {
        components:{
			boxRight,
            footerNew					
		},
        name: "businessArea",
        data(){
            return{
                mainTitle:"业务领域",
                liData:[
                    {name:"充电桩生产及销售业务",routerTo:"news",id:"1",type:"1",classification:'4-1'},
                    {name:"充电桩建设及运营业务",routerTo:"news",id:"2",type:"2",isActive:false,classification:'4-2'},
                    {name:"传感光伏业务",routerTo:"news",type:"3",id:"3",isActive:false,classification:'4-3'},
                    {name:"BIPV(光伏)业务",routerTo:"news",type:"4",id:"4",isActive:false,classification:'4-4'},
                    {name:"共享出行分时租赁",routerTo:"news",type:"5",id:"5",isActive:false,classification:'4-5'},
                    {name:"充电运营平台小程序解决方案",routerTo:"news",id:"6",type:"6",isActive:false,classification:'4-6'},
                ],
                listData:[
                    {text:'充电桩生产及销售业务',time:'2021-12-17',id:"1",type:"1",classification:'4-1'},
                    {text:'充电桩建设及运营业务',time:'2021-12-17',id:"2",type:"1",classification:'4-2'},
                    {text:'传感光伏业务',time:'2021-12-17',id:"3",type:"1",classification:'4-3'},
                    {text:'BIPV(光伏)业务',time:'2021-12-17',id:"4",type:"1",classification:'4-4'},
                    {text:'共享出行分时租赁',time:'2021-12-17',id:"5",type:"1",classification:'4-5'},
                    {text:'充电运营平台小程序解决方案',time:'2021-12-17',id:"6",type:"1",classification:'4-6'},

                ],
                type:'',
                typeTitle:"",
            }
        },
        methods:{
            goDetails(e){
                console.log(e)
               
                this.$router.push({name: "areaDetails",query:{data:e}});
                this.$store.commit('newSet',e.classification)
            },
            routerData(e){
                console.log(e)
                if(e.type){
                    this.$router.push({name: "areaDetails",query:{data:e}});
                    this.$store.commit('newSet',e.classification)
                }
            },
            originRouter(){
                this.listDataNew =  JSON.parse(JSON.stringify(this.listData))
                this.type = ''
                this.typeTitle = ''
                this.liData.map((item,index)=>{
                    item.isActive = false
                })
                this.$store.commit('newSet','4-7') 
            },
        },
        created(e){
            console.log(this.$route.query)
            let w = this.$route.query
            this.type = w.type
            this.listDataNew = JSON.parse(JSON.stringify(this.listData))
            if(this.type){
                if(this.type == '1'){
                   this.typeTitle = '媒体新闻'
                   this.liData[1].isActive = true
                }else if(this.type == '2'){
                    this.typeTitle = '公司新闻'
                    this.liData[0].isActive = true
                }
                let listDataNew = this.listData.filter((item,index)=>{
                    if(item.type == this.type){
                        return item
                    }
                })
                console.log(listDataNew)
                this.listDataNew = listDataNew
            }
        }
    }
</script>

<style scoped>
.text-c {
    text-align: center;
}
#pages {
    padding: 14px 0 10px;
    font-family: 宋体;
    overflow: hidden;
    margin: 0 auto;
    width: 100%;
}
.contentlist .listbox-left ul.list_c li {
    width: 100%;
    float: left;
    line-height: 30px;
    box-sizing: border-box;
}
.contentlist .listbox-left ul.list_c li a {
    float: left;
    font-size: 14px;
    color: #333333;
}
.contentlist .listbox-left ul.list_c li span {
    color: #898989;
    font-size: 14px;
    float: right;
}
.contentlist .listbox-left ul.list_c li {
    width: 100%;
    float: left;
    line-height: 30px;
    box-sizing: border-box;
}
.contentlist .listbox-left ul.list_c {
    width: 100%;
    float: left;
    margin: 15px 0;
    overflow: hidden;
}
.detailClass{
    margin-top: 0px; 
    margin-bottom: 0px; 
    padding: 15px 0px 15px 65px; 
    border-width: 0px 0px 1px; 
    border-top-style: initial; 
    border-right-style: initial; 
    border-bottom-style: solid; 
    border-left-style: initial; 
    border-top-color: initial; 
    border-right-color: initial; 
    border-bottom-color: rgb(221, 221, 221); 
    border-left-color: initial; 
    border-image: initial; 
    font-size: 15px; 
    line-height: 28px;
}
.monClass{
    margin: 0px; 
    padding: 0px; 
    border: 0px; 
    width: 52px; 
    height: 28px; 
    display: block; 
    background-color: rgb(185, 185, 185); 
    text-align: center; 
    color: rgb(255, 255, 255); 
    font-size: 18px;
}
.ulClass{
    margin: 0px; 
    padding: 0px; 
    border: 0px; 
    /* width: 80%;  */
    /* float: right;  */
    position: relative;
}
.h2Class{
    /* margin: 0px 0px 0px; */
    margin-right: 50px;
    padding: 0px; 
    font-size: 18px !important; 
    width: 80px; 
    /* float: left;  */
    color: rgb(137, 137, 137); 
    line-height: 28px;
}
.contentlist .Articlebox .a-text-c {
    font-size: 14px;
    line-height: 28px;
    color: #333333;
    display: block;
    padding: 10px 20px;
    margin-top: 15px;
}
.contentlist .Articlebox h2 {
    font-size: 14px;
    color: #CCC;
    display: block;
    line-height: 22px;
    text-align: center;
}
.contentlist .Articlebox h1 {
    display: block;
    padding: 45px 0 5px;
    text-align: center;
    font-size: 19px;
}
.contentlist .Articlebox {
    width: 780px;
    float: left;
    min-height: 600px;
}
     ul, ol, li {
    list-style: none;
}
#pages {
    padding: 14px 0 10px;
    font-family: 宋体;
    overflow: hidden;
    margin: 0 auto;
    width: 100%;
}
.text-c {
    text-align: center;
}
.contentlist .listbox-left ul.list_c {
    width: 100%;
    float: left;
    margin: 15px 0;
    overflow: hidden;
}
.contentlist .listbox-left ul.list_c li a {
    float: left;
    font-size: 14px;
    color: #333333;
}
.contentlist .listbox-left ul.list_c li a:hover {
   
    color: #18D1BB;
}
.contentlist .listbox-left ul.list_c li span {
    color: #898989;
    font-size: 14px;
    float: right;
}
.contentlist .listbox-left ul.list_c li {
    width: 100%;
    float: left;
    line-height: 30px;
    box-sizing: border-box;
}
  .footerbox .fott-box2 {
    width: 100%;
    float: left;
    height: 50px;
}
.footerbox .fott-box2 .box2-right span {
    font-size: 14px;
    color: #181818;
    margin: 0 15px;
}
.footerbox .fott-box2 .box2-right {
    float: right;
    line-height: 50px;
    color: #e4e4e4;
    font-family: Tahoma;
}
  .contentlist .listbox-right {
    float: right;
    width: 200px;
}
.contentlist .listbox-right ul li a:hover, .contentlist .listbox-right ul li a.active {
    color: #18D1BB;
}
.contentlist .listbox-right ul li a {
    float: left;
    font-size: 14px;
    color: #000;
}
.contentlist .listbox-right ul li {
    width: 100%;
    float: left;
    line-height: 32px;
    box-sizing: border-box;
    padding-left: 15px;
    background: url(../../static/images/don.gif) no-repeat 5px center;
}
.footerbox {
    margin: 0 auto;
    width: 100%;
    overflow: hidden;
    background: url(../../static/images/bottom_bg.jpg) repeat-x left bottom;
}
.contentlist .listbox-right ul {
    width: 100%;
    float: left;
    margin: 15px 0;
    height: 128px;
}
.contentlist .listbox-right h2 span {
    line-height: 48px;
    font-size: 18px;
    color: #000;
    float: left;
    margin-left: 10px;
}
.contentlist .listbox-right h2 {
    width: 100%;
    height: 48px;
    background-color: #f8f8f8;
    padding: 0 10px;
    box-sizing: border-box;
}
  .contentlist .Articlebox {
    width: 780px;
    float: left;
    min-height: 600px;
}
div, form, ul, ol, li, span, p, dl, dt, dd, img {
    margin: 0;
    padding: 0;
    border: 0;
}
.contentlist .Articlebox .a-text-c {
    font-size: 14px;
    line-height: 28px;
    color: #333333;
    display: block;
    padding: 10px 20px;
    margin-top: 15px;
}
.contentlist .Articlebox h1 {
    display: block;
    padding: 45px 0 5px;
    text-align: center;
    font-size: 19px;
}
  a {
    color: #20366f;
    text-decoration: none;
}
  .position {
    width: 100%;
    float: left;
    border-bottom: 1px solid #dddddd;
    font-family: Tahoma;
    font-size: 14px;
    color: #666666;
    padding: 15px 0;
}
.position a, .position span {
    display: inline-block;
    font-size: 14px;
    color: #666666;
    margin: 0 5px;
}
    .contentlist .listbox-left {
        width: 760px;
        float: left;
    }
  .contentlist {
    margin: 30px auto 15px;
    overflow: hidden;
    width: 100%;
}
.index-width {
    width: 1000px;
    margin: 0 auto;
    position: relative;
}
  .bannerbox {
    margin: 0 auto;
    overflow: hidden;
    width: 100%;
    height: 208px;
    object-fit: cover;
}
  .clearbox {
    border-top: 1px solid transparent !important;
    margin-top: -1px !important;
    margin-top: 0px;
    clear: both;
    font-size: 0px;
    line-height: 0px;
    height: 0px;
    border: 0px;
    visibility: hidden;
}
    *{
      box-sizing: border-box;
      margin:0;
      padding:0;
    }
</style>